module.exports = __webpack_public_path__ + "static/hr-c340738ed603afb569c27d85424e1387.svg";